import React from "react";
import { Row, Col, Button, FormControl, FormLabel } from "react-bootstrap";
import Select2 from 'react-select'
import "./quote-form.scss";
import { quoteSelectStyles } from "./quote-select-styles";

export const CustomerTopSection = ({ quote, handleChange, endUsersArray, handleEndUserChange, handleOpen }) => {
    return (
        <Row>
            <Col lg="6" className="mb-3">
                <FormLabel htmlFor="BillingFirstName">First name <span aria-hidden="true">*</span></FormLabel>
                <FormControl
                    required
                    className="input form-control custom-input"
                    type="text"
                    value={quote.BillingFirstName}
                    name="BillingFirstName"
					id="BillingFirstName"
                    onChange={handleChange}
                    placeholder="First Name"
                />
            </Col>
            <Col lg="6" className="mb-3">
				<FormLabel htmlFor="BillingLastName">Last name <span aria-hidden="true">*</span></FormLabel>
                <FormControl
                    required
                    className="input form-control custom-input"
                    type="text"
                    value={quote.BillingLastName}
                    name="BillingLastName"
					id="BillingLastName"
                    onChange={handleChange}
                    placeholder="Last Name"
                />
            </Col>
            <Col lg="12" className="mb-3">
				<FormLabel htmlFor="CustomerEmail">Email address <span aria-hidden="true">*</span></FormLabel>
                <FormControl
                    required
                    className="input form-control custom-input"
                    type="email"
                    value={quote.CustomerEmail}
                    name="CustomerEmail"
					id="CustomerEmail"
                    onChange={handleChange}
                    placeholder="Email Address"
                />
            </Col>
			<Col lg="8" className="mb-3">
				<FormLabel htmlFor="endUser">End user <span className="field-optional">Optional</span></FormLabel>
                <Select2
					inputId="endUser"
                    name="endUser"
                    onChange={handleEndUserChange}
                    placeholder="Search end users"
                    isClearable
                    value = {(endUsersArray && endUsersArray.length) && endUsersArray.find(elem => elem.value === quote.endUserId)}
                    styles={quoteSelectStyles}
                    label options={endUsersArray} 
                />
            </Col>
			<Col lg="4" className="mb-3 end-user-action">
            <Button variant="outline-primary" onClick={handleOpen} className="add-end-user-button">
				<i className="fa fa-plus" aria-hidden="true"></i> Add end user
            </Button>
            </Col>
        </Row>
    )
}